import React, { FC } from "react";
import { Select } from "antd";
import { Rate } from "~/design-system";
import { isFeeEarnerRow, useRowRateOptions } from "./use-row-rate-options";

type RowRateSelectProps = {
  row: any;
  currency: { symbol: string; code: string };
  matterId: number;
  clientId?: number;
  organisationalUnitId?: number;
  topDownRateOptions: {
    feeEarnerLevelId: number;
    order: number;
    rates: Pick<Rate, "id" | "description" | "amount">[];
  }[];
  onFeeEarnerLevelRateChange: (oldRateId: number, newRateId: number) => void;
  onFeeEarnerRateChange?: (
    feeEarnerId: number,
    oldRateId: number,
    newRateId: number,
    workId: number | null
  ) => void;
  onRateUpdate: (newRate: Rate) => void;
  onLargestRateUpdate: (ratePerMinute: number) => void;
  currentLargestRateMinute: number;
  className?: string;
};

export const RowRateSelect: FC<RowRateSelectProps> = ({
  row,
  currency,
  matterId,
  clientId,
  organisationalUnitId,
  topDownRateOptions,
  onFeeEarnerLevelRateChange,
  onFeeEarnerRateChange,
  onRateUpdate,
  onLargestRateUpdate,
  currentLargestRateMinute,
  className,
}) => {
  const { options } = useRowRateOptions({
    row,
    currency,
    matterId,
    clientId,
    organisationalUnitId,
    topDownRateOptions,
  });

  return (
    <Select
      value={row.rateId}
      className={className}
      dropdownMatchSelectWidth={true}
      dropdownStyle={{ minWidth: "200px" }}
      onChange={(newRateId: number) => {
        const oldRateId = row.rateId as number;
        if (oldRateId !== newRateId) {
          if (isFeeEarnerRow(row) && onFeeEarnerRateChange && row?.feeEarner?.id) {
            onFeeEarnerRateChange(row.feeEarner.id, oldRateId, newRateId, row.workId);
          } else {
            onFeeEarnerLevelRateChange(oldRateId, newRateId);
          }
        }
        const newRate = options.find((option) => option.id === newRateId);
        if (newRate) {
          onRateUpdate(newRate as Rate);
        }
        if (newRate && newRate.amount > currentLargestRateMinute) {
          onLargestRateUpdate(newRate.amount / 60);
        }
      }}
    >
      {options.map((option, index) => (
        <Select.Option key={index} value={option.id}>
          {`${currency.symbol}${option.amount} ${option.description}`}
        </Select.Option>
      ))}
    </Select>
  );
};
